module.exports = __webpack_public_path__ + "static/img/dreamWearFull.01dcc1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/dreamWearFull.png
// module id = sWoh
// module chunks = 1